import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { IconButton, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MessageModal } from 'components/modal/MessageModal';
import TextComponent from 'components/Input/TextComponent';
import MeetingFileImport from 'views/ClientCards/MeetingFileImport';

import { useRestApi } from 'context/RestApiContext';
import { checkRequired } from 'utils/validationUtils';
import { FreeProposalLevels } from 'constants/constants';

// 打合せ履歴モーダルダイアログ
function MeetingHistoryModal(props) {
  const restApi = useRestApi();

  const [show, setShow] = useState(false);
  const [clientCd, setClientCd] = useState('');
  const [mode, setMode] = useState('');
  const [meetingHistory, setMeetingHistory] = useState({});
  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);
  // メッセージモーダル
  const [dialog, setDialog] = useState({});

  const handleClose = () => setShow(false);

  useEffect(() => {
    if (props?.params?.show) {
      setClientCd(props.params.clientCd);
      setErrorFileds([]);
      setMode(props.params.mode);

      restApi.get(
        `/api/meeting_history/${props.params.clientCd}/${
          props.params.meetingHistory?.MEETING_NO ?? 0
        }`,
        (data) => {
          setMeetingHistory(data.meeting_history ?? { FREE_FLG: -1 });
          setShow(true);
        }
      );
    }
  }, [props.params]);

  // 編集処理
  const handleOnChange = (prop) => (target) => {
    setMeetingHistory({
      ...meetingHistory,
      [prop]: target?.value ?? target?.target.value,
    });
    setErrorFileds([...errorFileds].filter((x) => x != prop));
  };

  // ファイル番号を設定
  const setFileNo = (fileNo, prop) => {
    setMeetingHistory({
      ...meetingHistory,
      [prop]: fileNo,
    });
  };

  // 入力チェック
  const validate = (meetingHistory) => {
    let errors = [];
    checkRequired(meetingHistory.MEETING_DATE, '打合せ日', 'MEETING_DATE', errors);

    // タイトルが入力されている場合、URLも必須
    for (let i = 1; i <= 5; i++) {
      if (meetingHistory[`MOVIE${i}_TITLE`]) {
        checkRequired(
          meetingHistory[`MOVIE${i}_URL`],
          `動画URL${CIRCLED_NUMS[i - 1]}`,
          `MOVIE${i}_URL`,
          errors
        );
      }
      if (meetingHistory[`MOVIE${i}_URL`]) {
        checkRequired(
          meetingHistory[`MOVIE${i}_TITLE`],
          `動画タイトル${CIRCLED_NUMS[i - 1]}`,
          `MOVIE${i}_TITLE`,
          errors
        );
        // URL形式チェック
        if (
          !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
            meetingHistory[`MOVIE${i}_URL`]
          )
        ) {
          errors.push({
            msg: `・動画URL${CIRCLED_NUMS[i - 1]}の形式が不正です`,
            fields: [`MOVIE${i}_URL`],
          });
        }
      }
    }
    setErrorFileds(errors.flatMap((x) => x.fields));
    return errors.map((x) => x.msg);
  };

  // 保存ボタンをクリック
  const handleClickSave = () => {
    // 送信前に URL をトリム
    const payload = { ...meetingHistory, CLIENT_CD: clientCd };
    for (let i = 1; i <= 5; i++) {
      if (typeof payload[`MOVIE${i}_URL`] === 'string') {
        payload[`MOVIE${i}_URL`] = payload[`MOVIE${i}_URL`].trim();
      }
    }

    // 入力チェック
    var error = validate(payload);
    if (error.length > 0) {
      setDialog({
        type: 'error',
        message: error,
      });
      return;
    }

    restApi.post(`/api/meeting_history/${mode}`, { ...payload }, (_) => {
      props.params.callback();
      setShow(false);
    });
  };

  // 1〜5の丸数字
  const CIRCLED_NUMS = ['①', '②', '③', '④', '⑤'];

  return (
    <Dialog fullWidth maxWidth="lg" aria-labelledby="customized-dialog-title" open={show}>
      <DialogTitle>打合せ履歴</DialogTitle>
      <DialogContent>
        <Row>
          <Col md="3" className="p-0 pl-2">
            <label className="client-card-label">打合せ日</label>
            <TextComponent
              type="date"
              value={meetingHistory?.MEETING_DATE}
              onChange={handleOnChange('MEETING_DATE')}
              error={errorFileds.some((x) => x == 'MEETING_DATE')}
            />
          </Col>
          <Col md="8" className="p-0 pl-2">
            <label className="client-card-label">打合せ内容</label>
            <TextComponent
              type="text"
              value={meetingHistory?.MEETING_CONTENT}
              onChange={handleOnChange('MEETING_CONTENT')}
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col md="11" className="p-0 pl-2">
            <label className="client-card-label">連絡事項</label>
            <TextComponent
              type="textarea"
              rows={3}
              value={meetingHistory?.NOTE}
              onChange={handleOnChange('NOTE')}
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col md="11" className="p-0 pl-2">
            <label className="client-card-label">動画</label>
          </Col>
        </Row>
        {/* 動画/URL を 5 回ループ表示 */}
        {[1, 2, 3, 4, 5].map((i) => (
          <Row className={i === 1 ? 'mt-0' : 'mt-1'} key={`movie-row-${i}`}>
            <Col md="3" className="p-0 pl-2">
              <TextComponent
                type="text"
                placeholder={`動画タイトル${CIRCLED_NUMS[i - 1]}`}
                value={meetingHistory?.[`MOVIE${i}_TITLE`]}
                onChange={handleOnChange(`MOVIE${i}_TITLE`)}
                error={errorFileds.some((x) => x == `MOVIE${i}_TITLE`)}
              />
            </Col>
            <Col md="8" className="p-0 pl-2">
              <TextComponent
                type="text"
                placeholder={`動画URL${CIRCLED_NUMS[i - 1]}`}
                value={meetingHistory?.[`MOVIE${i}_URL`]}
                onChange={handleOnChange(`MOVIE${i}_URL`)}
                error={errorFileds.some((x) => x == `MOVIE${i}_URL`)}
              />
            </Col>
          </Row>
        ))}

        <Row className="mt-1">
          <Col md="11" className="p-0 pl-2">
            <label className="client-card-label">添付ファイル</label>
          </Col>
        </Row>
        <Row className="mt-0">
          {/* 添付ファイル を 6 回ループ表示 */}
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Col className="mt-2" md={4} key={`file-col-${i}`}>
              <MeetingFileImport
                fileName={meetingHistory?.[`TEMP_${i}_FILE_NAME`]}
                fileSize={meetingHistory?.[`TEMP_${i}_FILE_SIZE`]}
                setFileInfo={(fileNo) => {
                  setFileNo(fileNo, `TEMP_${i}_FILE_NO`);
                }}
                setDialog={setDialog}
              ></MeetingFileImport>
            </Col>
          ))}
        </Row>
        <Row className="mt-2">
          <Col md={3}>
            <label className="client-card-label">無料提案</label>
            {/* ラジオボタンに変更（定数で繰り返し） */}
            <div className="mt-0" style={{ display: 'flex', flexWrap: 'nowrap', gap: '16px' }}>
              {FreeProposalLevels.map((opt) => (
                <label
                  key={opt.key}
                  className="mr-3 mt-1"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontSize: '14pt',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <input
                    className="ml-2 mr-3"
                    style={{ transform: 'scale(1.5)' }}
                    type="radio"
                    name="free-proposal"
                    value={opt.key}
                    checked={meetingHistory?.FREE_FLG == opt.key}
                    onChange={(e) => {
                      setMeetingHistory({
                        ...meetingHistory,
                        FREE_FLG: parseInt(e.target.value, 10),
                      });
                    }}
                  />
                  {opt.value}
                </label>
              ))}
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
        <Button variant="secondary" className="footer-button" onClick={handleClose}>
          閉じる
        </Button>
        <Button
          variant="primary"
          className="btn-fill ml-4 mr-2"
          onClick={handleClickSave}
          style={{ flexGrow: 1 }}
        >
          保存
        </Button>
      </DialogActions>
      {/** メッセージモーダル */}
      <MessageModal dialog={dialog} />
    </Dialog>
  );
}
export default MeetingHistoryModal;
